<template>
    <v-row v-show="condition" style="height: 100vh;" class="p-5">
        <v-col cols="12" class="mb-15 pb-15">
            <v-progress-linear class="progress-bar" indeterminate rounded>
                {{ label }}
            </v-progress-linear>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        condition: {
            type: Boolean
        },
        label: {
            type: String
        }
    }
})

</script>